<template>

    <div class="d-flex element-container position-relative" :class="elementClasses" @click="onComponentClick">

        <div v-if="component.type === 'Field' && !isForm && !hasComponentStyles">
            {{fieldDisplayValue}}
        </div>

        <form-element v-if="component.type === 'Field' && isForm" :table="table" :field="component.value"
                      :document="document" :component="component.component"></form-element>

        <select-view v-if="component.type === 'Field' && component.value.field_type === 'Single Select'"
            :field="component.value"></select-view>

        <view-name-display v-if="component.type === 'View'" :view-id="component.value"></view-name-display>
        <label-renderer v-if="isLabel" :component="currentComponent" :layout="layout"></label-renderer>
        <text-renderer v-if="isText" :component="currentComponent" :layout="layout"></text-renderer>
        <header-renderer v-if="isHeader" :component="currentComponent" :layout="layout"></header-renderer>

        <link-renderer v-if="component.type === 'Link'" :component="component" :layout="layout"></link-renderer>
        <icon-renderer v-if="component.type === 'Icon'" :component="component" :layout="layout"></icon-renderer>
        <image-renderer v-if="component.type === 'Image'" :component="component"></image-renderer>
        <video-renderer v-if="component.type === 'Video'" :component="component"></video-renderer>
        <button-renderer v-if="component.type === 'Button'" :component="component" :layout="layout"></button-renderer>

        <row-component-renderer v-if="component.type === 'RowContainer'" :component="component"
                                :layout="layout"></row-component-renderer>

        <!-- dropdown editor -->
        <component-edit-dropdown :component="component" :column="column" :layout="layout"
                                 @containerWrapClick="onContainerWrapClick"
                                 @iconClick="$emit('iconClick')"
                                 @imageClick="$emit('imageClick')"></component-edit-dropdown>
    </div>

</template>

<script>
    import FormElement from "../../views/form/FormElement.vue";
    import TableUtil from "../../utils/TableUtil";
    import LabelRenderer from "../../views/renderers/LabelRenderer.vue";
    import HeaderRenderer from "../../views/renderers/HeaderRenderer.vue";
    import ViewNameDisplay from "./ViewNameDisplay.vue";
    import LinkRenderer from "../../views/renderers/LinkRenderer.vue";
    import IconRenderer from "../../views/renderers/IconRenderer.vue";
    import ImageRenderer from "../../views/renderers/ImageRenderer.vue";
    import ComponentEditDropdown from "./ComponentEditDropdown.vue";
    import ButtonRenderer from "../../views/renderers/ButtonRenderer.vue";
    import RowComponentRenderer from "../../views/renderers/RowComponentRenderer.vue";
    import ComponentUtil from "../../utils/ComponentUtil";
    import VideoRenderer from "../../views/renderers/VideoRenderer.vue";
    import TextRenderer from "../../views/renderers/TextRenderer.vue";
    import SelectView from "../../components/SelectView.vue";

    export default {
        name: 'ComponentContainer',
        components: {
            SelectView,
            TextRenderer,
            VideoRenderer,
            RowComponentRenderer,
            ButtonRenderer,
            ComponentEditDropdown,
            ImageRenderer,
            IconRenderer, LinkRenderer, ViewNameDisplay, HeaderRenderer, LabelRenderer, FormElement},
        props: ['column', 'component', 'layout', 'view'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            isForm() {
                return this.view.view_type === 'form'
            },
            isLabel() {
                return this.component.type === 'Label' || (this.hasComponentStyles && this.fieldComponent.type === 'Label' && !this.isForm)
            },
            isText() {
                return this.component.type === 'Text' || (this.hasComponentStyles && this.fieldComponent.type === 'Text' && !this.isForm)
            },
            isHeader() {
                return this.component.type === 'Header' || (this.hasComponentStyles && this.fieldComponent.type === 'Header' && !this.isForm)
            },
            currentComponent() {
                return this.hasComponentStyles ? this.fieldComponent : this.component
            },
            table() {
                return webase.utils.array.get(this.model.app.tables, this.view.model_id)
            },
            document() {
                return new TableUtil().createRecord(this.table)
            },
            elementClasses() {
                let classes =  this.marginClass + ' ' + this.paddingClass

                if(this.component.type === 'Field' && this.isForm) {
                    classes += ' w-100'
                }

                return classes
            },
            marginClass() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },
            paddingClass() {
                if(!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },
            fieldDisplayValue() {
                return 'Field: ' + this.component.value.name
            },
            hasComponentStyles() {
                return !!this.component.component && !!this.component.component.type && this.component.component.type !== 'Image'
            },
            fieldComponent() {
                this.component.component.value =  this.fieldDisplayValue
                return this.component.component
            }
        },
        methods: {
            onRemoveClick() {
                for (let j = 0; j < this.column.value.length; j++) {
                    let columnComponent = this.column.value[j]

                    if (columnComponent === this.component) {
                        this.column.value.splice(j, 1)
                        return
                    }
                }
            },
            onComponentClick() {
                if(this.component.type === 'RowContainer') {
                    return
                }

                webase.utils.layout.deselectComponents(this.layout)
                this.component.selected = true
                this.layout.selectedComponent = this.component
                //$('#componentContextMenu').dropdown('dispose')
            },

            onContainerWrapClick() {
                //$('#componentContextMenu').dropdown('dispose')
                let componentUtil = new ComponentUtil()
                componentUtil.wrapInContainer(this.column, this.component)
                this.$emit('columnRefresh')
            }
        }
    }
</script>

<style>
    .element-container {
        transform: none !important;
    }
</style>
